import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignRecruiterComponent } from './assign-recruiter.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AssignRecruiterComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  entryComponents: [AssignRecruiterComponent],
  exports: [AssignRecruiterComponent]
})
export class AssignRecruiterModule { }
